const ERROR_CODES = Object.freeze({
  FORBIDDEN: 403,
});

export default ERROR_CODES;
